import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ListOrdered } from "lucide-react";

export function VerificationQueuePanel({ workerVerified }: { workerVerified: boolean }) {
  const [q, setQ] = useState<any>(null);
  useEffect(() => { api.myVerificationQueue().then(setQ).catch(() => setQ(null)); }, []);
  if (!q) return null;
  if (workerVerified && !q.inQueue) return null; // already verified, nothing pending
  if (!q.inQueue) return null; // not in the queue (no pending submission)
  return (
    <div className="worker-profile-queue card p-5 mt-4 border-l-4 border-brand-gold">
      <h3 className="font-bold text-navy mb-1 flex items-center gap-2"><ListOrdered className="w-4 h-4" />Verification in progress</h3>
      <p className="text-sm text-mut">Your KYC documents are in the review queue.</p>
      <div className="flex items-end gap-4 mt-3">
        <div>
          <div className="text-3xl font-extrabold text-navy">#{q.position}</div>
          <div className="text-xs text-mut">your position</div>
        </div>
        <div className="text-sm text-mut mb-1">of <span className="font-semibold text-navy">{q.total}</span> pending {q.total === 1 ? "review" : "reviews"}</div>
      </div>
      <div className="h-2 rounded-full bg-navy-50 overflow-hidden mt-3">
        <div className="h-full bg-brand-gold transition-all" style={{ width: `${q.total ? Math.max(6, ((q.total - q.position + 1) / q.total) * 100) : 100}%` }} />
      </div>
      <p className="text-xs text-mut mt-2">We review submissions in the order received. You'll be notified as soon as a decision is made.</p>
    </div>
  );
}
